import { render, staticRenderFns } from "./LiveSocialChat.vue?vue&type=template&id=540620c2&scoped=true&"
import script from "./LiveSocialChat.vue?vue&type=script&lang=ts&"
export * from "./LiveSocialChat.vue?vue&type=script&lang=ts&"
import style0 from "./LiveSocialChat.vue?vue&type=style&index=0&id=540620c2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540620c2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VDivider,VMenu})
